import { workforceSettingRegistrations } from '../settings/workforce-setting-definitions.js';
import { workforceModuleManifest } from '../workforce.module.js';
import { workforceEmployeeProfileHostCapability, workforceEmployeeProfileHostSlots, } from '../contracts/workforce-employee-profile-host.contract.js';
export const workforceWebModuleContribution = {
    moduleId: 'workforce',
    manifest: workforceModuleManifest,
    settingRegistrations: workforceSettingRegistrations,
    settingEditors: [],
    hostContracts: [{
            capability: workforceEmployeeProfileHostCapability,
            slots: Object.values(workforceEmployeeProfileHostSlots),
        }],
    hostContributions: [],
    routes: [{
            id: 'workforce.web.directory',
            moduleId: 'workforce',
            path: '/workforce',
            requiredPermission: 'workforce.directory.read',
            navigation: {
                id: 'workforce.navigation.directory',
                fallbackLabel: 'Workforce',
                labelConfigurationKey: 'workforce.copy.directory',
                labelValueProperty: 'navigationLabel',
                priority: 75,
            },
            load: () => import('./workforce-directory.page.js'),
        }, {
            id: 'workforce.web.protected-forms',
            moduleId: 'workforce',
            path: '/workforce/forms',
            requiredPermission: 'workforce.hr-forms.manage',
            navigation: {
                id: 'workforce.navigation.protected-forms',
                fallbackLabel: 'Employee form setup',
                labelConfigurationKey: 'workforce.copy.protected-forms',
                labelValueProperty: 'navigationLabel',
                priority: 76,
            },
            load: () => import('./workforce-protected-forms.page.js'),
        }],
};
export default workforceWebModuleContribution;
//# sourceMappingURL=workforce-web.module-contribution.js.map